// Curated luxury font list — heading (serif display) + body (refined sans).
// value "" = site default (Bodoni Moda / Outfit), no extra font download.
const GF = (fam) => `https://fonts.googleapis.com/css2?family=${fam}&display=swap`;

export const HEADING_FONTS = [
  { name: "Bodoni Moda (default)", value: "", stack: "'Bodoni Moda', 'Times New Roman', serif" },
  { name: "Playfair Display", value: "Playfair Display", stack: "'Playfair Display', serif", url: GF("Playfair+Display:ital,wght@0,400..900;1,400..900") },
  { name: "Cormorant Garamond", value: "Cormorant Garamond", stack: "'Cormorant Garamond', serif", url: GF("Cormorant+Garamond:ital,wght@0,300..700;1,300..700") },
  { name: "Libre Caslon Text", value: "Libre Caslon Text", stack: "'Libre Caslon Text', serif", url: GF("Libre+Caslon+Text:ital,wght@0,400;0,700;1,400") },
  { name: "Cinzel", value: "Cinzel", stack: "'Cinzel', serif", url: GF("Cinzel:wght@400..900") },
  { name: "Marcellus", value: "Marcellus", stack: "'Marcellus', serif", url: GF("Marcellus") },
  { name: "Italiana", value: "Italiana", stack: "'Italiana', serif", url: GF("Italiana") },
  { name: "Prata", value: "Prata", stack: "'Prata', serif", url: GF("Prata") },
  { name: "DM Serif Display", value: "DM Serif Display", stack: "'DM Serif Display', serif", url: GF("DM+Serif+Display:ital@0;1") },
];

export const BODY_FONTS = [
  { name: "Outfit (default)", value: "", stack: "'Outfit', system-ui, sans-serif" },
  { name: "Jost", value: "Jost", stack: "'Jost', sans-serif", url: GF("Jost:ital,wght@0,100..900;1,100..900") },
  { name: "Lato", value: "Lato", stack: "'Lato', sans-serif", url: GF("Lato:ital,wght@0,300;0,400;0,700;1,400") },
  { name: "Montserrat", value: "Montserrat", stack: "'Montserrat', sans-serif", url: GF("Montserrat:ital,wght@0,100..900;1,100..900") },
  { name: "Karla", value: "Karla", stack: "'Karla', sans-serif", url: GF("Karla:ital,wght@0,200..800;1,200..800") },
  { name: "Mulish", value: "Mulish", stack: "'Mulish', sans-serif", url: GF("Mulish:ital,wght@0,200..1000;1,200..1000") },
  { name: "Figtree", value: "Figtree", stack: "'Figtree', sans-serif", url: GF("Figtree:ital,wght@0,300..900;1,300..900") },
];

export function ensureFontLoaded(f) {
  if (!f?.url) return;
  const id = `qw-font-${f.value.replace(/\s+/g, "-").toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = f.url;
  document.head.appendChild(link);
}

// Apply the admin-chosen font as a CSS variable. Empty value = default.
export function applyFont(kind, value) {
  const list = kind === "heading" ? HEADING_FONTS : BODY_FONTS;
  const varName = kind === "heading" ? "--font-heading" : "--font-body";
  const root = document.documentElement;
  const f = list.find((x) => x.value === (value || ""));
  if (!f || !f.value) {
    root.style.removeProperty(varName);
    return;
  }
  ensureFontLoaded(f);
  root.style.setProperty(varName, f.stack);
}
